<template>
  <div>
    <router-link :to="{path:'knowledgeBaseDetail' ,query:{id:item.KnowledgeId}}" class="bg-white rounded-lg d-block ">
      <v-img :src="$replaceHttps(item.FileUrl)" contain height="200"></v-img>
      <div class="text-center mt-2 font-weight-bold font-16 black--text">
        {{ item.Name }}
      </div>
      <div class="text-center mt-2 dark-gray-text pt-4">
        <div class="row mx-1">
          <div class="col-6 text-right"><span><i class="fas fa fa-eye ml-1"></i></span><span
              class="mb-1">{{ item.CountVisit }}</span></div>
          <div class="col-6 text-left">
            {{ $convertDate(item.ModifiedDate) }}
          </div>
        </div>
        <v-btn block class="mt-5" color="primary" elevation="0">
        <span class=" font-12">
        مشاهده
        </span>
        </v-btn>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "knowledgeBaseCard",
  props: ['item'],
}
</script>

<style scoped>

</style>